module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-harvardReview.360ae92253c542ffac123b7debd61870.png";